<template>
  <label>
    {{ $t('formPackage.roomType') }}
  </label>
</template>
